/****************************************************
 * Module Name:  AddMineModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../../utility/constants";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, CircularProgress } from "@mui/material";
import Utility from "../../../utility/utility";
import CommonSnackbar from "../../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import PhoneInput from "react-phone-input-2";
import MineProxy from "../../../utility/proxy/manager/manufacturingProxy/mineProxy";
import { CitySelect, CountrySelect, GetCity, GetCountries, GetState, StateSelect } from "react-country-state-city";

export default class AddMineModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newname: this.props.editOperation
                ? this.props.sourceData.name
                : "",
            newpocname: this.props.editOperation
                ? this.props.sourceData.pocname
                : "",
            newpocphonecode: this.props.editOperation
                ? this.props.sourceData.pocphonecode
                : "",
            newpocnumber: this.props.editOperation
                ? this.props.sourceData.pocnumber
                : "",
            newaddress1: this.props.editOperation
                ? this.props.sourceData.address1
                : "",
            newaddress2: this.props.editOperation
                ? this.props.sourceData.address2
                : "",
            newcity: this.props.editOperation
                ? this.props.sourceData.city
                : "",
            newstate: this.props.editOperation
                ? this.props.sourceData.state
                : "",
            newcountry: this.props.editOperation
                ? this.props.sourceData.country
                : "",
            newpincode: this.props.editOperation
                ? this.props.sourceData.pincode
                : "",

            showError: false,
            showValidationMessage: false,
            validateMineNamePresentSpinner: false,
            mineNameAvailable: true,
            defaultCountryForPhoneCode: "in",

            nameValidationError: "",

            selectedCountry: "",
            selectedState: "",
            selectedCity: "",
            countryid: 0,
            stateid: 0,
            cityid: 0,

            warning: false,
            warningmessage: "",
        };
    }

    componentDidMount() {
        this.getCountryStateCityData();
    }

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    getCountryStateCityData() {
        // Fetch all countries, and match saved values for prefill
        if (this.state.newcountry && this.state.newcountry !== "") {
            GetCountries().then((countries) => {
                const country = countries.find(
                    (c) => c.name.toLowerCase() === this.state.newcountry.toLowerCase()
                );

                if (country) {
                    this.setState({ selectedCountry: country, countryid: country.id });
                    // Fetch states based on prefilled country
                    GetState(country.id).then((states) => {
                        const state = states.find((s) => {
                            return s.name && this.state.newstate ? s.name.toLowerCase() === this.state.newstate.toLowerCase() : false
                        });

                        if (state) {
                            this.setState({ selectedState: state, stateid: state.id });
                            // Fetch cities based on prefilled state
                            GetCity(country.id, state.id).then(
                                (cities) => {
                                    const city = cities.find((c) => c.name.toLowerCase() === this.state.newcity.toLowerCase());

                                    if (city) {
                                        this.setState({ selectedCity: city, cityid: city.id, });
                                    }
                                }
                            );
                        }
                    });
                }
            });
        }
    }

    handleSave = () => {
        let data = {
            id: this.props.editOperation ? this.props.sourceData.id : undefined,
            name: this.state.newname,
            pocname: this.state.newpocname,
            pocphonecode: this.state.newpocphonecode,
            pocnumber: this.state.newpocnumber,
            address1: this.state.newaddress1,
            address2: this.state.newaddress2,
            city: this.state.newcity,
            state: this.state.newstate,
            country: this.state.newcountry,
            pincode: this.state.newpincode,
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data))
                    this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else
                this.props.handleSave(data);
        }
    };

    validateMineNamePresent = (mineNameEntered) => {
        if (!mineNameEntered || mineNameEntered.trim() === "") return;

        this.setState({
            validateMineNamePresentSpinner: true,
        });

        let minName = this.props.sourceData.name ? this.props.sourceData.name : "";
        if (minName.toLowerCase().trim() !== mineNameEntered.toLowerCase().trim()) {
            MineProxy.CheckMineNameAvailable(mineNameEntered, (response) => {
                //if we got response that means minename is present at backend
                if (response) {
                    this.setState({
                        validateMineNamePresentSpinner: false,
                        showValidationMessage: true,
                        mineNameAvailable: false,
                    });
                } else {
                    this.setState({
                        validateMineNamePresentSpinner: false,
                        showValidationMessage: true,
                        mineNameAvailable: true,
                    });
                }
            });
        } else {
            this.setState({
                validateMineNamePresentSpinner: false,
                mineNameAvailable: "",
                showValidationMessage: false,
            });
        }
    };

    buttonDisable = () => {
        const hasValidationErrors =
            !this.state.newname;
        // !this.state.newpocname ||
        // !this.state.newpocphonecode ||
        // !this.state.newpocnumber ||
        // !this.state.newaddress1 ||
        // !this.state.newaddress2 ||
        // !this.state.newcity ||
        // !this.state.newstate ||
        // !this.state.newcountry ||
        // !this.state.newpincode;

        return hasValidationErrors;
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add mine validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                <CommonSnackbar
                    show={this.state.warning}
                    message={this.state.warningmessage}
                    variant={"warning"}
                    autoHide={Constants.SnackBarCloseTimer}
                    title={"Warning"}
                    handleClose={() => {
                        this.setState({
                            warning: false,
                            warningmessage: ""
                        })
                    }}
                />

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit Mine" : "Add New Mine"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                {this.props.editOperation && (
                                    <tr>
                                        <td>
                                            <Form.Label>Mine Id</Form.Label>
                                        </td>
                                        <td>
                                            <Form.Label>{this.props.sourceData.id}</Form.Label>
                                        </td>
                                    </tr>
                                )}
                                {this.props.editOperation && (
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                )}
                                <tr>
                                    <td>
                                        <Form.Label>
                                            Mine Name <sup style={{ color: "red" }}>*</sup>
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Mine Name (required)"
                                            placeholder="Enter Mine Name"
                                            value={this.state.newname}
                                            onBlur={(e) =>
                                                this.validateMineNamePresent(e.target.value)
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    this.validateMineNamePresent(e.target.value)
                                                }
                                            }}
                                            onChange={(e) =>
                                                this.setState({
                                                    newname: e.target.value,
                                                    showValidationMessage: false,
                                                    nameValidationError: Utility.CheckIsPresent(
                                                        e.target.value
                                                    )
                                                        ? ""
                                                        : "Mine Name Cannot be Empty",
                                                })
                                            }
                                            helperText={this.state.nameValidationError}
                                            error={this.state.nameValidationError.length > 0}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        {this.state.validateMineNamePresentSpinner ? (
                                            <CircularProgress size="1rem" />
                                        ) : !this.state.showValidationMessage ? (
                                            <Box>&nbsp;</Box>
                                        ) : this.state.mineNameAvailable ? (
                                            <font color="green">Mine Name available</font>
                                        ) : (
                                            <font color="red">Mine Name not available</font>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            POC Name
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="POC Name"
                                            placeholder="Enter POC Name"
                                            value={this.state.newpocname}
                                            autoFocus
                                            onChange={(e) =>
                                                this.setState({
                                                    newpocname: e.target.value,
                                                })
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <table style={{ width: "100%" }}>
                                            <tr>
                                                <td style={{ width: "30%" }}>
                                                    <Form.Label style={{ margin: "0px", marginBottom: "8px" }}>Country Code</Form.Label>
                                                    <PhoneInput style={{ margin: "0px" }}
                                                        size="small"
                                                        key={this.state.newpocphonecode}
                                                        country={this.state.defaultCountryForPhoneCode}
                                                        enableSearch={true}
                                                        value={this.state.newpocphonecode}
                                                        defaultValue={this.state.newpocphonecode}
                                                        onChange={(phonecode) => {
                                                            this.setState({
                                                                newpocphonecode: phonecode,
                                                            });
                                                        }}
                                                        inputStyle={{
                                                            width: "110px",
                                                            height: "37px",
                                                            fontSize: "14px",
                                                        }}
                                                        inputProps={{
                                                            onKeyDown: (e) => e.preventDefault(),
                                                            placeholder: "",
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </td>
                                                <td style={{ width: "70%" }}>
                                                    <Form.Label style={{ margin: "0px", marginBottom: "8px" }}>POC Number</Form.Label>
                                                    <TextField style={{ margin: "0px" }}
                                                        margin="normal"
                                                        size="small"
                                                        fullWidth
                                                        label="POC Number"
                                                        placeholder="Enter POC Number"
                                                        value={this.state.newpocnumber}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                newpocnumber: e.target.value,
                                                            })
                                                        }
                                                        inputProps={{
                                                            style: {
                                                                width: "100%",
                                                            },
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            Country
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <CountrySelect style={{ height: "37px" }}
                                            key={this.state.countryid}
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeHolder="Select Country"
                                            value={this.state.countryid}
                                            defaultValue={this.state.selectedCountry}
                                            onChange={(e) => {
                                                this.setState({
                                                    selectedCountry: e,
                                                    countryid: e.id,
                                                    newcountry: e.name,
                                                    stateid: 0,
                                                    cityid: 0,
                                                    newstate: "",
                                                    newcity: "",
                                                    selectedCity: "",
                                                    selectedState: "",
                                                    newpocphonecode: String(e.phone_code),
                                                    // defaultCountryForPhoneCode: String(e.iso2.toLowerCase())
                                                });
                                            }}
                                            onBlur={(e) => {
                                                if (e.target.value === "") {
                                                    this.setState({
                                                        countryid: 0,
                                                        stateid: 0,
                                                        cityid: 0,
                                                        newcountry: "",
                                                        newstate: "",
                                                        newcity: "",
                                                        selectedCountry: "",
                                                        selectedCity: "",
                                                        selectedState: "",
                                                    });
                                                }
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            State
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <StateSelect style={{ height: "37px" }}
                                            key={this.state.countryid}
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            countryid={this.state.countryid}
                                            defaultValue={this.state.selectedState}
                                            placeHolder="Select State"
                                            value={this.state.stateid || ''}
                                            onChange={(e) => {
                                                this.setState({
                                                    selectedState: e,
                                                    stateid: e.id,
                                                    newstate: e.name,
                                                    cityid: 0,
                                                    newcity: "",
                                                    selectedCity: "",
                                                })
                                            }}
                                            onClick={(e) => {
                                                if (this.state.countryid === 0) {
                                                    this.setState({
                                                        warning: true,
                                                        warningmessage: "Please Select Country First"
                                                    })
                                                }
                                            }}
                                            onBlur={(e) => {
                                                if (e.target.value.trim() === "") {
                                                    this.setState({
                                                        stateid: 0,
                                                        cityid: 0,
                                                        newstate: "",
                                                        newcity: "",
                                                        selectedCity: "",
                                                        selectedState: "",
                                                    });
                                                }
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            City
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <CitySelect style={{ height: "37px" }}
                                            key={`${this.state.countryid}-${this.state.stateid}`}
                                            countryid={this.state.countryid}
                                            stateid={this.state.stateid}
                                            defaultValue={this.state.selectedCity}
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            placeHolder="Select City"
                                            value={this.state.cityid}
                                            onChange={(e) => {
                                                this.setState({
                                                    selectedCity: e,
                                                    cityid: e.id,
                                                    newcity: e.name,
                                                })
                                            }}
                                            onClick={(e) => {

                                                if (this.state.countryid === 0) {
                                                    this.setState({
                                                        warning: true,
                                                        warningmessage: "Please Select Country First"
                                                    })
                                                } else if (this.state.stateid === 0) {
                                                    this.setState({
                                                        warning: true,
                                                        warningmessage: "Please Select State First"
                                                    })
                                                }
                                            }}
                                            onBlur={(e) => {
                                                if (e.target.value.trim() === "") {
                                                    this.setState({
                                                        cityid: 0,
                                                        newcity: "",
                                                        selectedCity: "",
                                                    });
                                                }
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            Adress 1
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Address1"
                                            placeholder="Enter Address 1"
                                            value={this.state.newaddress1}
                                            autoFocus
                                            onChange={(e) =>
                                                this.setState({
                                                    newaddress1: e.target.value,
                                                })
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            Adress 2
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Address2"
                                            placeholder="Enter Address 2"
                                            value={this.state.newaddress2}
                                            autoFocus
                                            onChange={(e) =>
                                                this.setState({
                                                    newaddress2: e.target.value,
                                                })
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            Pincode
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Pincode"
                                            placeholder="Enter Pincode"
                                            value={this.state.newpincode}
                                            autoFocus
                                            onChange={(e) =>
                                                this.setState({
                                                    newpincode: e.target.value,
                                                })
                                            }
                                        />
                                    </td>
                                </tr>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        )
    }


}